import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarContribuinteDs,
  criarMunicipioDs,
  criarNotaFiscalAvulsaDs,
  criarPaisBacenDs,
  criarServicosIssDs,
  criarNbsDs,
} from "../../DataSources";
import { Button, ScrollView } from "devextreme-react";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import uiInfo from "../../ui-info";
import { Editing } from "devextreme-react/scheduler";
import {
  Column,
  DataGrid,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import ServicosIssBox from "../servicosIss/ServicosIssBox";
import {
  NumberBox as NumberBoxControl,
  Button as NumberBoxButton,
} from "devextreme-react/number-box";
import ShowError from "../../AppServices";
import axios from "../../api-axios";
import { detalheNotaAvulsa } from "../../lancamentosUtils";
import Memoria from "../../Memoria";
import { LoadIndicator } from "devextreme-react/load-indicator";
import NbsBox from "../nbs/NbsBox";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  tomadorId: undefined,
  prestadorId: undefined,
  prestadorTipo: "",
  prestadorOptanteSimples: 0,
  servicoId: undefined,
  nbsCodigo: undefined,
  numero: undefined,
  codigoVerificacao: undefined,
  status: undefined,
  data: undefined,
  competencia: undefined,
  aliquota: 0,
  valorIss: 0,
  issRetido: false,
  valorTotal: 0,
  inss: 0,
  irrf: 0,
  pis: 0,
  cofins: 0,
  csll: 0,
  sest: 0,
  senat: 0,
  deducoes: 0,
  valorOutrasRetencoes: 0,
  valorDescontoCondicionado: 0,
  valorDescontoIncondicionado: 0,
  tributacaoIss: 0,
  tipoDescricao: 0,
  total: 0,
  historico: "",
  itens: [],
  popupPrestadorVisivel: false,
  popupTomadorVisivel: false,
  date: "2020-09-13T00:49:22.656Z",
  exibirPopupPreview: false,
  previewData: {},
  _uiInssIrrfData: { calculando: false },
  _uiSestSenatData: { calculando: false },
  paisPrestacaoId: 1058,
  _uiServicoObra: false
};

export default class NotaFiscalAvulsaForm extends React.Component {
  constructor(props) {
    super(props);
    this.configs = {};
    this.refTributacaoIss = React.createRef();
    this.gridItensRef = React.createRef();
    this.formRef = React.createRef();
    this.form2Ref = React.createRef();
    this.frmTributacao = React.createRef();
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.calcularTotalItens = this.calcularTotalItens.bind(this);
    this.onServicoSelecionado = this.onServicoSelecionado.bind(this);
    this.setServicoId = this.setServicoId.bind(this);
    this.setDescricaoServico = this.setDadosServico.bind(this);
    this.atualizarDescricaoServico = this.atualizarDescricaoServico.bind(this);
    this.pesquisarServico = this.pesquisarServico.bind(this);
    this.confirmar = this.confirmar.bind(this);
    this.confirmarPopup = this.confirmarPopup.bind(this);
    this.confirmarTela = this.confirmarTela.bind(this);
    this.cancel = this.cancel.bind(this);
    const dataCorrente = new Date();

    this.state = {
      ...(_cadastroCorrente || template),
      dataDeEmissao: dataCorrente,
      dataDoServico: dataCorrente,
      vencimento: dataCorrente,
      prefeituraId: UserInfo.getPrefeitura(),
      popupPrestadorVisivel: false,
      popupTomadorVisivel: false,
      popupServicoVisivel: false,
      _uiCarregando: true,
    };
    console.log("state", this.state);
    this.nfDs = criarNotaFiscalAvulsaDs();
    this.paisBacenDs = criarPaisBacenDs();
    this.contribuinteDs = criarContribuinteDs();
    this.aliquotaDs = criarServicosIssDs();

    //
    /* Funções do Prestador
     */
    this.setPrestadorId = this.setPrestadorId.bind(this);
    this.atualizarNomePrestador = this.atualizarNomePrestador.bind(this);
    this.setNomePrestador = this.setNomePrestador.bind(this);
    this.pesquisarPrestador = this.pesquisarPrestador.bind(this);
    this.onPrestadorSelecionadoPesquisa =
      this.onPrestadorSelecionadoPesquisa.bind(this);
    this.prestadorBoxRef = React.createRef();

    this.renderPrestador = sysCodigoDescricao(
      () => this.state.prestadorId,
      this.setPrestadorId,
      () => this.state._uiNomePrestador,
      this.pesquisarPrestador
    );

    //
    /* Fim das funções do Prestador
     */

    //
    /* Funções do Tomador
     */
    this.setTomadorId = this.setTomadorId.bind(this);
    this.atualizarNomeTomador = this.atualizarNomeTomador.bind(this);
    this.setNomeTomador = this.setNomeTomador.bind(this);
    this.pesquisarTomador = this.pesquisarTomador.bind(this);
    this.onTomadorSelecionadoPesquisa =
      this.onTomadorSelecionadoPesquisa.bind(this);
    this.tomadorBoxRef = React.createRef();

    this.renderTomador = sysCodigoDescricao(
      () => this.state.tomadorId,
      this.setTomadorId,
      () => this.state._uiNomeTomador,
      this.pesquisarTomador
    );

    this.servicoBoxRef = React.createRef();

    this.renderServico = sysCodigoDescricao(
      () => this.state.servicoId,
      this.setServicoId,
      () => this.state._uiServico,
      this.pesquisarServico
    );

    //
    /* Fim das funções do Tomador
     */

    const valoresModelo = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Selecione...",
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.opcoesStatus = {
      editorType: "dxSelectBox",
      placeholder: " ",
      readOnly: true,
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "EMITIDA" },
        { id: 1, descricao: "CANCELADA" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.issRetidoOpcoes = { ...valoresModelo };

    this.inssOpcoes = {
      ...valoresModelo,
      onValueChanged: (e) => {
        if (e.event) {
          this.setState({ _calcularInss: e.value });
        }
      },
    };

    this.irrfOpcoes = {
      ...valoresModelo,
      onValueChanged: (e) => {
        if (e.event) {
          this.setState({ _calcularIrrf: e.value });
        }
      },
    };

    this.setTributacaoIss = this.setTributacaoIss.bind(this);

    this.setTipoHistorico = this.setTipoHistorico.bind(this);

    this.historicoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "HISTÓRICO" },
        { id: 1, descricao: "ITENS" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: this.setTipoHistorico,
    };

    this.renderTxtInss = this.renderTxtInss.bind(this);
    this.renderTxtIrrf = this.renderTxtIrrf.bind(this);
    this.calcularInssIrrf = this.calcularInssIrrf.bind(this);
    this.calcularSestSenat = this.calcularSestSenat.bind(this);
    this.renderTxtSest = this.renderTxtSest.bind(this);
    this.renderTxtSenat = this.renderTxtSenat.bind(this);
    this.solicitarCalculoInssIrrf = this.solicitarCalculoInssIrrf.bind(this);
    this.solicitarCalculoSestSenat = this.solicitarCalculoSestSenat.bind(this);

    this.nbsDs = null;

    this.setNbsId = this.setNbsId.bind(this);
    this.pesquisarNbs = this.pesquisarNbs.bind(this);
    this.setDadosNbs = this.setDadosNbs.bind(this);
    this.atualizarDescricaoNbs = this.atualizarDescricaoNbs.bind(this);
    this.onNbsSelecionado = this.onNbsSelecionado.bind(this);

    this.renderNbs = sysCodigoDescricao(
      () => this.state.nbsCodigo,
      this.setNbsId,
      () => this.state._uiNbs,
      this.pesquisarNbs
    );

    this.optanteSimplesOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: " " },
        { id: 1, descricao: "NÃO OPTANTE" },
        { id: 2, descricao: "OPTANTE MEI" },
        { id: 3, descricao: "OPTANTE" },
      ],
      valueExpr: "id",
      displayExpr: "descricao"
    };

    this.getPessoaInfoAdn = this.getPessoaInfoAdn.bind(this);
    this.renderDadosObra = this.renderDadosObra.bind(this);
  }

  setNbsId(e) {
    console.log("nbs selecionado e", e);
    this.setState({ nbsCodigo: e.value });
    this.atualizarDescricaoNbs();
  }

  atualizarDescricaoNbs() {

    if (this.nbsDs == null) {
      console.log("nbs ds is null")
      this.setDadosNbs(null, "É obrigatório selecionar o serviço antes do NBS");
      return;
    }

    this.nbsDs
      .load({
        filter: [
          ["codigo", "=", this.state.nbsCodigo],
          "OR",
          ["codigoFormatado", "=", this.state.nbsCodigo]
        ]
      })
      .then((result) => {
        console.log("nbs result", result);
        if (result.length !== 0) {
          this.setDadosNbs(result[0]);
        } else {
          this.setDadosNbs(null);
        }
      })
      .catch((_) => this.setDadosNbs(null));
  }

  pesquisarNbs(e) {

    if (this.state._uiCodigoLcp116 == null) {
      notify("Selecione primeiro o serviço municipal", "warning");
      return;
    }

    this.setState({ _uiPopupNbsVisivel: true });

  }

  setDadosNbs(nbs, customMessage) {
    console.log("nbs", nbs);
    if (nbs == undefined) {
      this.setState({
        nbsCodigo: null,
        _uiNbs: customMessage ?? "",
        _uiPopupNbsVisivel: false
      });
    } else {
      this.setState({
        nbsCodigo: nbs.codigo,
        _uiNbs: nbs.descricao,
        _uiPopupNbsVisivel: false,
      });
    }
  }

  onNbsSelecionado(e) {
    console.log("Nbs Selecionado", e);

    const nbs = e?.row?.data;

    if (!nbs) {
      this.setState({ _uiPopupNbsVisivel: false });
      return;
    }

    this.setState({
      nbsCodigo: nbs.codigo,
      _uiNbs: nbs.descricao,
      _uiPopupNbsVisivel: false
    });

  }

  setTributacaoIss(e) {
    this.setState({ tributacaoIss: e.value });
    this.atualizarDescricaoServico();
    this.frmTributacao.current.instance.getEditor("tributacaoIss").focus();
  }
  setTipoHistorico(e) {
    this.setState({
      tipoDescricao: e.value,
      valorTotal: e.value == 1 ? null : this.state.valorTotal,
    });
    this.form2Ref.current.instance.getEditor("tipoDescricao").focus();
  }

  renderTxtInss() {
    return (
      <NumberBoxControl
        value={this.state.inss}
        format={uiInfo.formatoNumerico.n2}
        className={"txtNumerico"}
        onValueChanged={(e) => this.setState({ inss: e.value })}
      >
        <NumberBoxButton
          name="btnCalcularInss"
          location="after"
          options={{
            icon: "datafield",
            onClick: this.calcularInssIrrf,
            focusStateEnabled: false,
            visible:
              this.configs.exibirCalculoRetencoes != undefined &&
              this.configs.exibirCalculoRetencoes,
          }}
        />
      </NumberBoxControl>
    );
  }

  renderTxtIrrf() {
    return (
      <NumberBoxControl
        value={this.state.irrf}
        format={uiInfo.formatoNumerico.n2}
        className={"txtNumerico"}
        onValueChanged={(e) => this.setState({ irrf: e.value })}
      >
        <NumberBoxButton
          name="btnCalcularIrrf"
          location="after"
          options={{
            icon: "datafield",
            onClick: this.calcularInssIrrf,
            focusStateEnabled: false,
            visible:
              this.configs.exibirCalculoRetencoes != undefined &&
              this.configs.exibirCalculoRetencoes,
          }}
        />
      </NumberBoxControl>
    );
  }

  renderTxtSest() {
    return (
      <NumberBoxControl
        value={this.state.sest}
        format={uiInfo.formatoNumerico.n2}
        className={"txtNumerico"}
        onValueChanged={(e) => this.setState({ sest: e.value })}
      >
        <NumberBoxButton
          name="btnCalcularSest"
          location="after"
          options={{
            icon: "datafield",
            onClick: this.calcularSestSenat,
            focusStateEnabled: false,
            visible:
              this.configs.exibirCalculoRetencoes != undefined &&
              this.configs.exibirCalculoRetencoes,
          }}
        />
      </NumberBoxControl>
    );
  }

  renderTxtSenat() {
    return (
      <NumberBoxControl
        value={this.state.senat}
        format={uiInfo.formatoNumerico.n2}
        className={"txtNumerico"}
        onValueChanged={(e) => this.setState({ senat: e.value })}
      >
        <NumberBoxButton
          name="btnCalcularSenat"
          location="after"
          options={{
            icon: "datafield",
            onClick: this.calcularSestSenat,
            focusStateEnabled: false,
            visible:
              this.configs.exibirCalculoRetencoes != undefined &&
              this.configs.exibirCalculoRetencoes,
          }}
        />
      </NumberBoxControl>
    );
  }

  calcularInssIrrf() {
    this.setState({
      popupInssIrrfVisivel: true,
      _uiInssIrrfData: {
        calcularInss: true,
        calcularIrrf: true,
        qtdeDependentes: 0,
        msgDependentes:
          "Lembre-se que deve arquivar o comprovante de dependência para apresentação a eventual fiscalização futura!",
      },
    });
  }

  async solicitarCalculoInssIrrf() {
    try {
      console.log("estado calculando sest/senat", this.state);

      const resp = await axios.post("/nota_fiscal_avulsa/calcular_inss_irrf", {
        calcularInss: this.state._uiInssIrrfData.calcularInss,
        calcularIrrf: this.state._uiInssIrrfData.calcularIrrf,
        total: this.state.valorTotal,
        competencia: this.state.dataDoServico,
        nfAvulsaCorrenteId: this.state.id,
        prestadorId: this.state.prestadorId,
        prefeituraId: UserInfo.getPrefeitura(),
        servicoId: this.state.servicoId,
        calcularSest: this.state._uiInssIrrfData.calcularInss,
        calcularSenat: this.state._uiInssIrrfData.calcularIrrf,
        qtdeDependentes: this.state._uiInssIrrfData.qtdeDependentes,
      });

      console.log("resp sest/senat", resp);

      this.setState({
        inss: resp.data.inss,
        irrf: resp.data.irrf,
        popupInssIrrfVisivel: false,
        _uiInssIrrfData: {
          calculando: false,
          calcularInss: true,
          calcularIrrf: true,
          qtdeDependentes: 0,
        },
      });
    } catch (error) {
      ShowError(error.response.data);

      this.setState({
        popupInssIrrfVisivel: false,
        _uiInssIrrfData: {
          calculando: false,
          calcularInss: true,
          calcularIrrf: true,
        },
      });
    }
  }

  async calcularSestSenat() {
    this.setState({
      popupSestSenatVisivel: true,
      _uiSestSenatData: { calcularSest: true, calcularSenat: true },
    });
  }

  async solicitarCalculoSestSenat() {
    try {
      console.log("estado calculando sest/senat", this.state);
      const resp = await axios.post("/nota_fiscal_avulsa/calcular_sest_senat", {
        total: this.state.valorTotal,
        prefeituraId: UserInfo.getPrefeitura(),
        calcularSest: this.state._uiSestSenatData.calcularSest,
        calcularSenat: this.state._uiSestSenatData.calcularSenat,
      });

      console.log("resp sest/senat", resp);

      this.setState({
        sest: resp.data.sest,
        senat: resp.data.senat,
        popupSestSenatVisivel: false,
        _uiSestSenatData: {
          calculando: false,
          calcularSest: true,
          calcularSenat: true,
        },
      });
    } catch (error) {
      ShowError(error);

      this.setState({
        popupSestSenatVisivel: false,
        _uiSestSenatData: {
          calculando: false,
          calcularSest: true,
          calcularSenat: true,
        },
      });
    }
  }

  calcularTotalItens(options) {
    console.log(options);
    if (options.name === "somaTotal") {
      if (options.summaryProcess === "start") {
        options.totalValue = 0;
      } else if (options.summaryProcess === "calculate") {
        console.log("options value", options.value);
        const row = options.value;
        options.totalValue = options.totalValue + row.qtde * row.valorUnitario;
      }
    }
  }

  //
  /* Funções do Prestador
   */

  setPrestadorId(e) {
    this.setState({ prestadorId: e.value });
    this.atualizarNomePrestador();
  }

  atualizarNomePrestador() {

    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.prestadorId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomePrestador(result[0]);
        } else {
          this.setNomePrestador(undefined);
        }
      })
      .catch((_) => this.setNomePrestador(null));
  }

  getPessoaInfoAdn(contribuinte) {
    let tipoPessoa = "";
    let optanteSimples = 0;

    if (contribuinte.tipoPessoa === 1) {
      tipoPessoa = "PF";
      optanteSimples = 1;
    }
    else if (contribuinte.tipoPessoa === 2) {
      tipoPessoa = "PJ";
    }

    return { tipoPessoa, optanteSimples };
  }

  setNomePrestador(contribuinte) {

    if (contribuinte == undefined) {
      this.setState({ prestadorId: "", popupPrestadorVisivel: false, _uiNomePrestador: "", prestadorTipo: "", prestadorOptanteSimples: 1 });
      return;
    }

    const { tipoPessoa, optanteSimples } = this.getPessoaInfoAdn(contribuinte);

    console.log("tipo pessoa", tipoPessoa, "optanteSimples", optanteSimples)
    this.setState({ prestadorId: contribuinte.sequencial, popupPrestadorVisivel: false, _uiNomePrestador: contribuinte.nome, prestadorTipo: tipoPessoa, prestadorOptanteSimples: optanteSimples });
  }

  onPrestadorSelecionadoPesquisa(e) {
    this.setNomePrestador(e.row.data);
  }

  pesquisarPrestador() {
    this.prestadorBoxRef.current.limparFiltro();
    this.setState({ popupPrestadorVisivel: true });
  }

  //
  /* Fim das funções do Prestador
   */

  //
  /* Funções do Tomador
   */

  setTomadorId(e) {
    this.setState({ tomadorId: e.value });
    this.atualizarNomeTomador();
  }

  atualizarNomeTomador() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.tomadorId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomeTomador(result[0]);
        } else {
          this.setNomeTomador(undefined);
        }
      })
      .catch((_) => this.setNomeTomador(null));
  }

  setNomeTomador(contribuinte) {
    if (contribuinte == undefined) {
      this.setState({ _uiNomeTomador: "" });
    } else {
      this.setState({ _uiNomeTomador: contribuinte.nome });
    }
  }

  onTomadorSelecionadoPesquisa(e) {
    this.setState({
      tomadorId: e.row.data.sequencial,
      _uiNomeTomador: e.row.data.nome,
      popupTomadorVisivel: false,
    });
  }

  pesquisarTomador() {
    this.tomadorBoxRef.current.limparFiltro();
    this.setState({ popupTomadorVisivel: true });
  }

  setServicoId(e) {
    console.log("servico selecionado e", e);
    this.setState({ servicoId: e.value });
    this.atualizarDescricaoServico();
  }

  atualizarDescricaoServico() {
    this.aliquotaDs
      .load({ filter: [["sequencial", "=", this.state.servicoId]] })
      .then((result) => {
        console.log("servico result", result);
        if (result.length !== 0) {
          this.setDadosServico(result[0]);
        } else {
          this.setDadosServico(null);
        }
      })
      .catch((_) => this.setDadosServico(null));
  }

  setDadosServico(servico) {
    console.log("servico", servico);
    if (servico == undefined) {
      this.nbsDs = null;

      this.setState({
        servicoId: null,
        _uiServico: "",
        _uiCodigoLcp116: "",
        _uiNbs: "",
        _uiServicoObra: false,
        nbsCodigo: "",
        aliquotaIss: this.state.tributacaoIss != 3 ? null : this.state.aliquotaIss,
        popupServicoVisivel: false,
      });

    } else {

      console.log(servico);

      this.nbsDs = criarNbsDs(servico.lcFederal);

      this.setState({
        servicoId: servico.sequencial,
        _uiServico: servico.descricao,
        _uiCodigoLcp116: servico.lcFederal,
        _uiNbs: "",
        _uiServicoObra: servico.stDadosObraObrigatorio,
        nbsCodigo: "",
        aliquotaIss:
          this.state.tributacaoIss != 3
            ? servico.aliquotaIss
            : this.state.aliquotaIss,
        popupServicoVisivel: false,
      });
    }
  }

  pesquisarServico(e) {
    this.setState({ popupServicoVisivel: true });
  }

  onServicoSelecionado(e, entidadeDireta) {
    console.log("serviço selecionado e", e, "entidade", entidadeDireta);
    let servico = entidadeDireta;
    if (servico == undefined && e && e.row && e.row.data) {
      servico = e.row.data;
    }
    this.setDadosServico(servico);
  }

  //
  /* Fim das funções do Tomador
   */

  async componentDidMount() {
    this.municipiosDs = criarMunicipioDs();

    console.log("props nf avulsa", this.props);
    const results = await Promise.all([
      this.municipiosDs.load(),
      axios.get(
        `/nota_fiscal_avulsa/${UserInfo.getPrefeitura()}/start_nf_avulsa`
      ),
      this.paisBacenDs.load(),
    ]);

    this.municipioOptions = {
      editorType: "dxLookup",
      searchEnabled: true,
      dataSource: results[0],
      valueExpr: "id",
      displayExpr: "nomeCompleto",
    };

    this.localPrestacaoOptions = {
      editorType: "dxLookup",
      searchEnabled: true,
      dataSource: results[0],
      valueExpr: "id",
      displayExpr: "nomeCompleto",
      onValueChanged: (e) => this.setState({ localPrestacaoId: e.value }),
    };

    this.paisOptions = {
      editorType: "dxLookup",
      placeholder: " ",
      searchEnabled: true,
      dataSource: results[2],
      valueExpr: "id",
      displayExpr: "nome",
    };

    this.configs = results[1].data;

    let tributacoes = [
      { id: 0, descricao: "NO MUNICIPIO" },
      { id: 1, descricao: "IMUNE" },
      { id: 2, descricao: "ISENTO" },
      { id: 3, descricao: "OUTRO MUNICIPIO" },
      { id: 4, descricao: "AUTÔNOMO (ISS FIXO)" },
    ];

    if (!results[1].data.aceitaForaMunicipio) {
      tributacoes = tributacoes.filter((x) => x.id != 3);
    }

    this.tributacaoIssOptions = {
      editorType: "dxLookup",
      searchEnabled: false,
      dataSource: tributacoes,
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: this.setTributacaoIss,
    };

    if (this.props.match.params.id !== undefined) {
      this.nfDs
        .load({ filter: [["sequencial", "=", this.props.match.params.id]] })
        .then((data) => {
          if (data == undefined) {
            notify("nota fiscal não encontrada.", "error");
            this.props.history.goBack();
          }

          console.log("nf aberta", data);

          const nf = data[0];

          const { tipoPessoa, optanteSimples } = this.getPessoaInfoAdn(nf.prestador);

          console.log("dados prestador pegos - tipo pessoa", tipoPessoa, "optante simples", optanteSimples);

          let novoEstado = {
            id: nf.id,
            prefeituraId: nf.prefeituraId,
            tomadorId: nf.tomador == undefined ? null : nf.tomador.sequencial,
            _uiNomePrestador: nf.prestador == undefined ? "" : nf.prestador.nome,
            prestadorId:
              nf.prestador == undefined ? null : nf.prestador.sequencial,
            _uiNomeTomador: nf.tomador == undefined ? "" : nf.tomador.nome,
            servicoId: nf.servico == undefined ? null : nf.servico.sequencial,
            _uiServico:
              nf.servico == undefined ? "" : nf.servico.descricao.toUpperCase(),
            numero: nf.numero,
            codigoVerificacao: nf.codigoVerificacao,
            status: nf.status,
            data: nf.dataDeEmissao,
            competencia: nf.dataDoServico,
            vencimento: nf.vencimento,
            aliquotaIss: nf.aliquota,
            iss: nf.iss,
            issRetido: nf.issRetido,
            valorTotal: nf.valorTotal,
            inss: nf.inss,
            irrf: nf.irrf,
            pis: nf.pis,
            cofins: nf.cofins,
            csll: nf.csll,
            sest: nf.sest,
            senat: nf.senat,
            deducoes: nf.deducoes,
            outrasRetencoes: nf.outrasRetencoes,
            descontoCondicionado: nf.descontoCondicionado,
            descontoIncondicionado: nf.descontoIncondicionado,
            tributacaoIss: nf.tributacaoIss,
            tipoDescricao: nf.tipoDescricao,
            historico: nf.historico,
            municipioIssId: nf.municipioIssId,
            municipioPrestacaoId: nf.municipioPrestacaoId,
            paisPrestacaoId: nf.paisPrestacaoId,
            itens: [],
            popupPrestadorVisivel: false,
            popupTomadorVisivel: false,
            previewData: {},
            _uiInssIrrfData: { calculando: false },
            _uiSestSenatData: { calculando: false },
            _uiCarregando: false,
            nbsCodigo: nf.nbs?.codigo ?? "",
            _uiNbs: nf.nbs?.descricao,
            prestadorTipo: tipoPessoa,
            prestadorOptanteSimples: optanteSimples,
            _uiServicoObra: nf.servico.stDadosObraObrigatorio,
            obraCib: nf.obraCib,
            obraCep: nf.obraCep,
            obraLogradouro: nf.obraLogradouro,
            obraNumero: nf.obraNumero,
            obraComplemento: nf.obraComplemento,
            obraBairro: nf.obraBairro,
          };

          if (nf.tipoDescricao == 1 && nf.itens != undefined && nf.itens.length > 1) {
            novoEstado.itens = nf.itens.map((i) => {
              return {
                item: i.item,
                descricao: i.descricao,
                qtde: i.qtde,
                valorUnitario: i.valorUnitario,
                total: i.total,
              };
            });
            novoEstado.valorTotal = null;
          }

          this.setState(novoEstado);
          console.log("novo estado", novoEstado);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    } else {
      _cadastroCorrente = Memoria.resturarEstado(
        this.props.location,
        _cadastroCorrente,
        _versaoCadastro
      );

      if (_cadastroCorrente === undefined) {
        this.setState({
          ...template,
          prefeituraId: UserInfo.getPrefeitura(),
          paisPrestacaoId: 1058,
          municipioPrestacaoId: results[1].data.municipioId,
          municipioIssId: results[1].data.municipioId,
          configs: results[1].data,
          _uiCarregando: false,
        });
      } else {
        this.setState({
          ..._cadastroCorrente,
          configs: results[1].data,
          _uiCarregando: false,
        });
      }
    }

    _cancelando = false;
  }

  componentWillUnmount() {
    _cadastroCorrente = _cancelando ? undefined : this.state;

    if (_cadastroCorrente != undefined) {
      _cadastroCorrente._uiCarregando = false;
      Memoria.emEdicao(this.props.location, _cadastroCorrente, _versaoCadastro);
    }
  }

  render() {
    if (this.state._uiCarregando) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <LoadIndicator width={60} height={60} />
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form
              formData={this.state}
              colCount={3}
              labelLocation={"top"}
              ref={this.formRef}
            >
              <GroupItem caption="NOTA FISCAL AVULSA" colSpan={3} colCount={6}>
                <SimpleItem
                  colSpan={1}
                  dataField={"numero"}
                  cssClass={"readOnlyBox"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Número" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  cssClass={"readOnlyBox"}
                  dataField={"codigoVerificacao"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Cod. Verificação" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  cssClass={"readOnlyBox"}
                  dataField={"status"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.opcoesStatus}
                >
                  <Label text="Status" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField="dataDeEmissao"
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Data" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"dataDoServico"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Competência" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField="vencimento"
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Vencimento" />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="PRESTADOR" colSpan={3} colCount={8}>
                <SimpleItem colSpan={5} component={this.renderPrestador}>
                  <Label text="Código" />
                </SimpleItem>
                <SimpleItem colSpan={1} dataField={"prestadorTipo"} editorOptions={{ readOnly: true }}>
                  <Label text={"Tipo"} />
                </SimpleItem>
                <SimpleItem colSpan={2} dataField={"prestadorOptanteSimples"} editorType={"dxSelectBox"} editorOptions={{ ...this.optanteSimplesOptions, readOnly: this.state.prestadorTipo === "PJ" ? false : true }}>
                  <Label text={"Optante Simples"} />
                </SimpleItem>
                <SimpleItem colSpan={1} />
              </GroupItem>
              <GroupItem caption="TOMADOR" colSpan={3} colCount={6}>
                <SimpleItem colSpan={6} component={this.renderTomador}>
                  <Label text="Código" />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption="CLASSIFICAÇÃO DO SERVIÇO" colSpan={3} colCount={6}>
                <SimpleItem colSpan={6} component={this.renderServico}>
                  <Label text="Serviço" />
                </SimpleItem>

                <SimpleItem colSpan={6} component={this.renderNbs}>
                  <Label text="NBS" />
                </SimpleItem>
              </GroupItem>
            </Form>

            <div>
              <Form formData={this.state} colCount={3} ref={this.form2Ref}>
                <GroupItem caption="DESCRIÇÃO DO SERVIÇO" colSpan={3} colCount={3}>
                  <SimpleItem
                    colSpan={6}
                    dataField={"tipoDescricao"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.historicoOptions}
                    visible={
                      this.configs.aceitaItens != undefined &&
                      this.configs.aceitaItens
                    }
                  >
                    <Label text="Tipo de Histórico" />
                  </SimpleItem>

                  <EmptyItem
                    colSpan={2}
                    visible={
                      this.state.tipoDescricao == 0 &&
                      this.configs.aceitaItens != undefined &&
                      this.configs.aceitaItens
                    }
                  />

                  <SimpleItem
                    dataField={"historico"}
                    editorType={"dxTextArea"}
                    editorOptions={{ height: "120px" }}
                    colSpan={3}
                    visible={this.state.tipoDescricao == 0}
                  >
                    <Label
                      text="Histórico"
                      visible={
                        this.configs != undefined && this.configs.aceitaItens
                      }
                    />
                  </SimpleItem>
                </GroupItem>
              </Form>
            </div>
            <div
              style={{ display: this.state.tipoDescricao === 1 ? "" : "none" }}
            >
              <PaginaToolbar
                titulo="Itens da nota"
                ocultarExibicaoFiltro={true}
              >
                <DataGrid
                  dataSource={this.state.itens}
                  showBorders={true}
                  rowAlternationEnabled={true}
                  remoteOperations={false}
                  wordWrapEnabled={true}
                  ref={this.gridItensRef}
                >
                  <Editing
                    mode={"row"}
                    allowAdding={false}
                    allowUpdating={true}
                    allowDeleting={true}
                    useIcons={true}
                  />
                  <Column dataField={"item"} visible={false} />
                  <Column dataField={"descricao"} caption={"Descrição"} />
                  <Column
                    width={120}
                    dataField={"qtde"}
                    caption={"Quantidade"}
                    dataType={"number"}
                    editorType={"dxNumberBox"}
                    format={uiInfo.formatoNumerico.n2}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  />
                  <Column
                    width={120}
                    dataField={"valorUnitario"}
                    caption={"Vr. Unitário (R$)"}
                    dataType={"number"}
                    editorType={"dxNumberBox"}
                    format={uiInfo.formatoNumerico.n2}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  />
                  <Column
                    width={150}
                    dataField={"total"}
                    caption={"Total (R$)"}
                    dataType={"number"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    format={uiInfo.formatoNumerico.n2}
                    calculateCellValue={(rowData) => {
                      if (isNaN(rowData.qtde * rowData.valorUnitario)) return 0;
                      else return rowData.qtde * rowData.valorUnitario;
                    }}
                    allowEditing={false}
                  />

                  <Summary calculateCustomSummary={this.calcularTotalItens}>
                    <TotalItem
                      summaryType="count"
                      valueFormat={"00"}
                      displayFormat={"Qtde. Itens: {0}"}
                      showInColumn="descricao"
                    />
                    <TotalItem
                      name="somaTotal"
                      summaryType="custom"
                      valueFormat="R$ #,##0.00"
                      displayFormat={"Total: {0}"}
                      showInColumn="total"
                    />
                  </Summary>
                </DataGrid>
              </PaginaToolbar>
            </div>

            <br />

            {this.renderDadosObra()}

            <Form
              formData={this.state}
              colCount={3}
              labelLocation={"top"}
              ref={this.frmTributacao}
            >
              <GroupItem caption={"TRIBUTAÇÃO"} colSpan={3} colCount={4}>
                <SimpleItem
                  colSpan={1}
                  dataField={"valorTotal"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    readOnly: this.state.tipoDescricao == 1,
                  }}
                  visible={this.state.tipoDescricao == 0}
                >
                  <Label text="Total da Nota" />
                </SimpleItem>

                <SimpleItem
                  colSpan={this.state.tipoDescricao == 0 ? 1 : 2}
                  dataField={"tributacaoIss"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tributacaoIssOptions}
                >
                  <Label text="Tributação" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"municipioPrestacaoId"}
                  editorType={"dxLookup"}
                  editorOptions={this.localPrestacaoOptions}
                >
                  <Label text="Município da Prestação" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"paisPrestacaoId"}
                  editorType={"dxLookup"}
                  editorOptions={{
                    ...this.paisOptions,
                    readOnly: this.state.municipioPrestacaoId != 9999,
                  }}
                >
                  <Label text="País de Prestação" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"municipioIssId"}
                  editorType={"dxLookup"}
                  editorOptions={{
                    ...this.municipioOptions,
                    readOnly: this.state.tributacaoIss != 3,
                  }}
                >
                  <Label text="Município de Incidência" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"aliquotaIss"}
                  editorType={"dxNumberBox"}
                  cssClass={"txtNumerico"}
                  editorOptions={{
                    readOnly: this.state.tributacaoIss != 3,
                    format: uiInfo.formatoNumerico.n2,
                  }}
                >
                  <Label text="Alíquota ISS" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"issRetido"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.issRetidoOpcoes}
                >
                  <Label text="ISS Retido" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"deducoes"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Deduções" />
                </SimpleItem>
              </GroupItem>
              <GroupItem
                caption={"RETENÇÕES E OUTROS"}
                colSpan={3}
                colCount={5}
              >
                <SimpleItem render={this.renderTxtInss}>
                  <Label text="INSS" />
                </SimpleItem>

                <SimpleItem render={this.renderTxtIrrf}>
                  <Label text="IRRF" />
                </SimpleItem>

                <SimpleItem
                  dataField={"pis"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="PIS" />
                </SimpleItem>

                <SimpleItem
                  dataField={"cofins"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="COFINS" />
                </SimpleItem>

                <SimpleItem
                  dataField={"csll"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="CSLL" />
                </SimpleItem>

                <SimpleItem
                  dataField={"outrasRetencoes"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Outras Retenções" />
                </SimpleItem>

                <SimpleItem
                  dataField={"descontoCondicionado"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Desc. Condicionado" />
                </SimpleItem>

                <SimpleItem
                  dataField={"descontoIncondicionado"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Desc. Incondicionado" />
                </SimpleItem>

                <SimpleItem render={this.renderTxtSest}>
                  <Label text="SEST" />
                </SimpleItem>

                <SimpleItem render={this.renderTxtSenat}>
                  <Label text="SENAT" />
                </SimpleItem>
              </GroupItem>
            </Form>

            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "left",
                alignContent: "left",
                justifyItems: "left",
                alignItems: "left",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.confirmarTela}
                />
              </div>
              <div style={{ marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Cancelar"
                  type="default"
                  onClick={this.cancel}
                />
              </div>
              <div style={{ display: "none", marginLeft: "10px" }}>
                <Button text="Fechar" onClick={this.cancel} width={120} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupPrestadorVisivel}
            onHiding={() => this.setState({ popupPrestadorVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onPrestadorSelecionadoPesquisa}
                ref={this.prestadorBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupPrestadorVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>

          <Popup
            visible={this.state.popupTomadorVisivel}
            onHiding={() => this.setState({ popupTomadorVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Serviço"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onTomadorSelecionadoPesquisa}
                ref={this.tomadorBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupTomadorVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.popupServicoVisivel}
            onHiding={() => this.setState({ popupServicoVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Serviço"
          >
            <ScrollView showScrollbar={"always"}>
              <ServicosIssBox
                onSelecionado={this.onServicoSelecionado}
                ref={this.servicoBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupServicoVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.exibirPopupPreview}
            onHiding={() => this.setState({ exibirPopupPreview: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={660}
            title="Confirmação dos dados"
          >
            <ScrollView showScrollbar="always">
              <form>
                <Form
                  formData={this.state.previewData}
                  colCount={6}
                  className="readOnlyBGless"
                  labelLocation={"top"}
                >
                  <SimpleItem
                    dataField={"msgInss"}
                    colSpan={6}
                    editorOptions={{ readOnly: true }}
                    visible={
                      this.state.previewData.msgInss != undefined &&
                      this.state.previewData.msgInss != ""
                    }
                  >
                    <Label text="Alerta INSS" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"msgIrrf"}
                    colSpan={6}
                    editorOptions={{ readOnly: true }}
                    visible={
                      this.state.previewData.msgIrrf != undefined &&
                      this.state.previewData.msgIrrf != ""
                    }
                  >
                    <Label text="Alerta INSS" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"prestadorNome"}
                    colSpan={5}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="Prestador" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"prestadorCpfCnpj"}
                    colSpan={1}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="CPF/CNPJ" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"tomadorNome"}
                    colSpan={5}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="Tomador" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"tomadorCpfCnpj"}
                    colSpan={1}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="CPF/CNPJ" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"servico"}
                    colSpan={6}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="Serviço" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"tributacao"}
                    colSpan={1}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="Tributação" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"valorTotal"}
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Total da Nota (R$)" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"deducoes"}
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Deduções(R$)" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"baseCalculo"}
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Base de Cálculo" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"aliquotaIss"}
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Alíquota Iss (%)" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"iss"}
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Valor ISS (R$)" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"issRetido"}
                    colSpan={1}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="ISS Retido" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"inss"}
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Valor INSS (R$)" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"irrf"}
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Valor IRRF (R$)" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"pis"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="PIS" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"cofins"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="COFINS" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"csll"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="CSLL" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"outrasRetencoes"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Outras Retenções" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"sest"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="SEST" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"senat"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="SENAT" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"descontoCondicionado"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Desc. Condicionado" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"descontoIncondicionado"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Desc. Incondicionado" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"valorLiquido"}
                    render={this.itemLeitura}
                    colSpan={1}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: true,
                    }}
                  >
                    <Label text="Valor Líquido (R$)" />
                  </SimpleItem>
                </Form>
              </form>
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Confirmar",
                type: "success",
                width: 150,
                onClick: this.confirmarPopup,
              }}
            ></ToolbarItem>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Cancelar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ exibirPopupPreview: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
        <Popup
          visible={this.state.popupInssIrrfVisivel}
          onHiding={() => this.setState({ popupInssIrrfVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={true}
          showTitle={true}
          width={400}
          height={320}
          title="INSS/IRRF"
        >
          <Form
            formData={this.state._uiInssIrrfData}
            className="readOnlyBGless"
          >
            <SimpleItem
              dataField={"calcularInss"}
              editorType={"dxCheckBox"}
              labelLocation={"rigth"}
              editorOptions={{ text: "Calcular INSS" }}
            >
              <Label visible={false} />
            </SimpleItem>
            <SimpleItem
              dataField={"calcularIrrf"}
              editorType={"dxCheckBox"}
              labelLocation={"rigth"}
              editorOptions={{ text: "Calcular IRRF" }}
            >
              <Label visible={false} />
            </SimpleItem>
            <SimpleItem
              dataField={"qtdeDependentes"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.inteiroSemPonto }}
            >
              <Label text={"Qtde. de Dependentes"} />
            </SimpleItem>
            <SimpleItem
              dataField={"msgDependentes"}
              editorType={"dxTextArea"}
              editorOptions={{
                readOnly: true,
                width: "100%",
                height: 90,
                contentAlign: "center",
              }}
            >
              <Label visible={false} />
            </SimpleItem>
          </Form>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              disabled: this.state._uiInssIrrfData.calculando,
              text: this.state._uiInssIrrfData.calculando
                ? "Calculando..."
                : "Calcular",
              type: "success",
              onClick: this.solicitarCalculoInssIrrf,
            }}
          />

          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              disabled: this.state._uiInssIrrfData.calculando,
              text: "Cancelar",
              type: "default",
              onClick: () => this.setState({ popupInssIrrfVisivel: false }),
            }}
          />
        </Popup>
        <Popup
          visible={this.state.popupSestSenatVisivel}
          onHiding={() => this.setState({ popupSestSenatVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={true}
          showTitle={true}
          width={250}
          height={170}
          title="SEST/SENAT"
        >
          <Form
            formData={this.state._uiSestSenatData}
            className="readOnlyBGless"
          >
            <SimpleItem
              dataField={"calcularSest"}
              editorType={"dxCheckBox"}
              labelLocation={"rigth"}
              editorOptions={{ text: "Calcular SEST" }}
            >
              <Label visible={false} />
            </SimpleItem>
            <SimpleItem
              dataField={"calcularSenat"}
              editorType={"dxCheckBox"}
              labelLocation={"rigth"}
              editorOptions={{ text: "Calcular SENAT" }}
            >
              <Label visible={false} />
            </SimpleItem>
          </Form>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              disabled: this.state._uiSestSenatData.calculando,
              text: this.state._uiSestSenatData.calculando
                ? "Calculando..."
                : "Calcular",
              type: "success",
              onClick: this.solicitarCalculoSestSenat,
            }}
          />

          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              disabled: this.state._uiSestSenatData.calculando,
              text: "Cancelar",
              type: "default",
              onClick: () => this.setState({ popupSestSenatVisivel: false }),
            }}
          />
        </Popup>
        <Popup
          visible={this.state._uiPopupNbsVisivel}
          onHiding={() => this.setState({ _uiPopupNbsVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title={`Pesquisa NBS para LCP 116 ${this.state_uiCodigoLcp116}`}
        >
          <ScrollView showScrollbar={"always"}>
            <NbsBox codigoLcp116={this.state._uiCodigoLcp116} onSelecionado={(e) => this.onNbsSelecionado(e)} />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ _uiPopupNbsVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  confirmarPopup() {
    this.confirmar(false);
  }

  confirmarTela() {
    this.confirmar(true);
  }

  confirmar(preview) {
    let entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    if (entidade.tipoDescricao == 1) {
      entidade.valorTotal = 0;
    }

    entidade.preview = preview;

    inserirOuAtualizar(this.nfDs, entidade).then((data) => {
      console.log("data preview", data);
      if (preview) {
        const nf = data.nf;

        const prestadorNome =
          nf.prestador != undefined ? nf.prestador.nome : "";
        const prestadorCpfCnpj =
          nf.prestador != undefined ? nf.prestador.documentoFormatado : "";
        const tomadorNome = nf.tomador != undefined ? nf.tomador.nome : "";
        const tomadorCpfCnpj =
          nf.tomador != undefined ? nf.tomador.documentoFormatado : "";
        const servico =
          nf.servico != undefined
            ? `${nf.servico.lcMunicipal} - ${nf.servico.descricao}`
            : "";
        const tributacao = nf.tributacaoIssStr;
        const aliquotaIss = nf.aliquota;
        const iss = nf.iss;
        const issRetido = nf.issRetidoStr;
        const inss = nf.inss;
        const irrf = nf.irrf;
        const pis = nf.pis;
        const cofins = nf.cofins;
        const csll = nf.csll;
        const outrasRetencoes = nf.outrasRetencoes;
        const sest = nf.sest;
        const senat = nf.senat;
        const descontoIncondicionado = nf.descontoIncondicionado;
        const descontoCondicionado = nf.descontoCondicionado;
        const valorLiquido = nf.valorLiquido;
        const valorTotal = nf.valorTotal;
        const baseCalculo = nf.baseCalculo;
        const deducoes = nf.deducoes;
        this.setState({
          exibirPopupPreview: true,
          previewData: {
            msgInss: data.msgInss,
            msgIrrf: data.msgIrrf,
            prestadorNome,
            prestadorCpfCnpj,
            tomadorNome,
            tomadorCpfCnpj,
            servico,
            tributacao,
            aliquotaIss,
            iss,
            issRetido,
            inss,
            irrf,
            valorLiquido,
            valorTotal,
            pis,
            cofins,
            csll,
            outrasRetencoes,
            sest,
            senat,
            descontoIncondicionado,
            descontoCondicionado,
            baseCalculo,
            deducoes,
          },
        });
      } else {
        _cadastroCorrente = undefined;
        _cancelando = true;
        Memoria.removerEdicao(this.props.location);
        detalheNotaAvulsa(this.props.history, data.nf);
      }
    });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }

  renderDadosObra() {

    if (!this.state._uiServicoObra) return null;

    return (
      <>
        <Form
          formData={this.state}
          colCount={4}
          labelLocation={"top"}
          ref={this.frmTributacao}
        >
          <GroupItem caption={"DADOS DA OBRA"} colSpan={4} colCount={4}>
            <SimpleItem
              dataField={"obraCep"}
              editorOptions={{ mask: "00000-000" }}
              colSpan={1}>
              <Label text="CEP" />
            </SimpleItem>


            <SimpleItem dataField={"obraLogradouro"} colSpan={2}>
              <Label text="Logradouro" />
            </SimpleItem>

            <SimpleItem dataField={"obraNumero"} colSpan={1}>
              <Label text="N.º" />
            </SimpleItem>

            <SimpleItem dataField={"obraComplemento"} colSpan={1}>
              <Label text="Complemento" />
            </SimpleItem>

            <SimpleItem dataField={"obraBairro"} colSpan={2}>
              <Label text="Bairro" />
            </SimpleItem>

            <SimpleItem dataField={"obraCIB"} colSpan={1}>
              <Label text="CIB Imóvel Obra" />
            </SimpleItem>

          </GroupItem>
        </Form>
        <br />
      </>
    );
  }
}
